// On a phone, choosing a colour brings the product gallery back into view so the shopper can check the new picture.
// Colour swatches of the main product page only: the quick-view dialog and desktop (gallery beside the picker) are left alone.
const phone = window.matchMedia('(max-width: 749px)');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
  if (!input.closest('variant-picker .variant-option--swatches') || input.closest('dialog')) return;
  if (!phone.matches) return;

  const gallery = document.querySelector('product-information media-gallery') || document.querySelector('media-gallery');
  if (!gallery || gallery.closest('dialog')) return;

  // The header declares its mode in a sticky attribute ("scroll-up" or "always"). With "scroll-up" it is not stuck yet
  // while the page is scrolled down, but it reappears as soon as we scroll up, so reserve its height either way.
  const header = document.querySelector('header-component');
  const offset = header && ['always', 'scroll-up'].includes(header.getAttribute('sticky')) ? header.getBoundingClientRect().height : 0;
  const rect = gallery.getBoundingClientRect();
  if (rect.top >= offset && rect.bottom <= window.innerHeight) return; // already fully visible

  window.scrollTo({ top: window.scrollY + rect.top - offset, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
});
